import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  class: "card-header",
  style: {"font-size":"14px","font-weight":"bold"}
}

import { reactive, shallowReactive, ref, getCurrentInstance, onMounted } from 'vue'
import Keys from '@/constant/key'
import { useStore } from '@/store/index'
import { joinParams } from '@/utils'
import {getImportListApi} from '@/apis/others'
import {getBrandListApi} from '@/apis/brand'

export default /*@__PURE__*/_defineComponent({
  __name: 'OrderReport',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
const store = useStore()
const params = ref([])
const brands = ref([])
const isLoading = ref(true)

// 为每个模块定义独立的品牌选择变量
const brandNames3 = ref('')
const brandNames5 = ref('')
const brandNames25 = ref('')
const brandNames26 = ref('')


const brandProps = {
    label: 'name',
    value: 'id',
}
// 获取品牌列表
const getBrandList = async () => {
    const res = await getBrandListApi({ noLoading: true })
    if(res.code == 200) {
        brands.value = res.data
    } else {
        proxy.$message.error(res.msg || '获取品牌列表失败')
    }
}

const onExport = (item) => {
    // 3/5/25/26模块需要品牌选择
    let processedBrandIds = ''
    if(item.id == 3 || item.id == 5 || item.id == 25 || item.id == 26) {
        // 处理品牌数据
        let brandIds = []
        if (item.filterData.brand_ids) {
            if (typeof item.filterData.brand_ids === 'string') {
                brandIds = brandIds.concat(item.filterData.brand_ids.split(','))
            } else if (Array.isArray(item.filterData.brand_ids)) {
                brandIds = brandIds.concat(item.filterData.brand_ids)
            }
        }
        if (item.filterData.brand_name && Array.isArray(item.filterData.brand_name)) {
            brandIds = brandIds.concat(item.filterData.brand_name)
        }
        const uniqueBrandIds = [...new Set(brandIds)].filter(Boolean)
        processedBrandIds = uniqueBrandIds.join(',')
    }
    
    const {id} = item  
    
    // 构建导出参数
    const exportParams = {
        ...item.filterData,
        user_id: store.state.user.userInfo.id
    }
    if (processedBrandIds) {
        exportParams.brand_ids = processedBrandIds
        delete exportParams.brand_name
    }
    // 根据不同的报表类型调用不同的导出接口
    window.open(`${Keys.baseUrl}/sys/admin/doImportOrders?${joinParams(exportParams)}&id=${id}&is_export=1`)
}

const getImportList = async () => {
    const res = await getImportListApi({
        user_id: store.state.user.userInfo.id,
        noLoading: true
    })
    if(res.code == 200) {
        // 为每个模块添加独立的 filterData 对象，使用shallowReactive减少响应式开销
        params.value = res.data.map(item => ({
            ...item,
            filterData: shallowReactive({})
        }))
    } else {
        proxy.$message.error(res.msg || '获取失败')
    }
}

onMounted(async () => {
    try {
        // 并行执行异步请求，减少加载时间
        await Promise.all([
            getImportList(),
            getBrandList()
        ])
        console.log('数据加载完成')
    } catch (err) {
        console.error('数据加载失败:', err)
    } finally {
        // 无论成功失败，都关闭加载状态
        isLoading.value = false
    }
})

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_skeleton, {
            rows: 3,
            animated: ""
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(params.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: item.id,
              class: "mb15"
            }, [
              _createVNode(_component_el_card, { shadow: "hover" }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(item.name), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    inline: true,
                    class: "filter-form"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.report_params, (param, paramIndex) => {
                        return (_openBlock(), _createBlock(_component_el_form_item, {
                          key: paramIndex,
                          label: param.title + '：'
                        }, {
                          default: _withCtx(() => [
                            (param.input_type === 'date')
                              ? (_openBlock(), _createBlock(_component_el_date_picker, {
                                  key: 0,
                                  modelValue: item.filterData[param.name],
                                  "onUpdate:modelValue": ($event: any) => ((item.filterData[param.name]) = $event),
                                  type: "date",
                                  placeholder: param.placeholder || '选择日期',
                                  class: "filter-item date-input",
                                  format: "YYYY-MM-DD",
                                  "value-format": "YYYY-MM-DD"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                              : (param.input_type === 'text')
                                ? (_openBlock(), _createBlock(_component_el_input, {
                                    key: 1,
                                    modelValue: item.filterData[param.name],
                                    "onUpdate:modelValue": ($event: any) => ((item.filterData[param.name]) = $event),
                                    placeholder: param.placeholder || '输入' + param.title,
                                    class: "filter-item input-item"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                                : (param.input_type === 'array')
                                  ? (_openBlock(), _createBlock(_component_el_select, {
                                      key: 2,
                                      modelValue: item.filterData[param.name],
                                      "onUpdate:modelValue": ($event: any) => ((item.filterData[param.name]) = $event),
                                      placeholder: param.placeholder || '选择' + param.title,
                                      class: "filter-item select-item"
                                    }, {
                                      default: _withCtx(() => [
                                        (param.input_params)
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(param.input_params, (option) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: option.lable_id,
                                                label: option.lable_name,
                                                value: option.lable_id
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["modelValue", "onUpdate:modelValue", "placeholder"]))
                                  : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["label"]))
                      }), 128)),
                      (item.id === 3 && brands.value.length > 0)
                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                            key: 0,
                            label: "品牌："
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select_v2, {
                                modelValue: brandNames3.value,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((brandNames3).value = $event)),
                                multiple: "",
                                filterable: "",
                                clearable: "",
                                placeholder: '选择品牌',
                                class: "filter-item select-item brand-select",
                                onChange: ($event: any) => (item.filterData.brand_name = brandNames3.value),
                                options: brands.value,
                                props: brandProps
                              }, null, 8, ["modelValue", "onChange", "options"])
                            ]),
                            _: 2
                          }, 1024))
                        : (item.id === 5 && brands.value.length > 0)
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 1,
                              label: "品牌："
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_select_v2, {
                                  modelValue: brandNames5.value,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((brandNames5).value = $event)),
                                  multiple: "",
                                  filterable: "",
                                  clearable: "",
                                  placeholder: '选择品牌',
                                  class: "filter-item select-item brand-select",
                                  onChange: ($event: any) => (item.filterData.brand_name = brandNames5.value),
                                  props: brandProps,
                                  options: brands.value
                                }, null, 8, ["modelValue", "onChange", "options"])
                              ]),
                              _: 2
                            }, 1024))
                          : (item.id === 25 && brands.value.length > 0)
                            ? (_openBlock(), _createBlock(_component_el_form_item, {
                                key: 2,
                                label: "品牌："
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select_v2, {
                                    modelValue: brandNames25.value,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((brandNames25).value = $event)),
                                    multiple: "",
                                    filterable: "",
                                    clearable: "",
                                    placeholder: '选择品牌',
                                    class: "filter-item select-item brand-select",
                                    onChange: ($event: any) => (item.filterData.brand_name = brandNames25.value),
                                    props: brandProps,
                                    options: brands.value
                                  }, null, 8, ["modelValue", "onChange", "options"])
                                ]),
                                _: 2
                              }, 1024))
                            : (item.id === 26 && brands.value.length > 0)
                              ? (_openBlock(), _createBlock(_component_el_form_item, {
                                  key: 3,
                                  label: "品牌："
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select_v2, {
                                      modelValue: brandNames26.value,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((brandNames26).value = $event)),
                                      multiple: "",
                                      filterable: "",
                                      clearable: "",
                                      placeholder: '选择品牌',
                                      class: "filter-item select-item brand-select",
                                      onChange: ($event: any) => (item.filterData.brand_name = brandNames26.value),
                                      props: brandProps,
                                      options: brands.value
                                    }, null, 8, ["modelValue", "onChange", "options"])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: ($event: any) => (onExport(item)),
                            class: "export-btn"
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode("导出")
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ]))
  ]))
}
}

})